import _styled31 from "../web_modules/styled-components.js";
import _styled30 from "../web_modules/styled-components.js";
import _styled29 from "../web_modules/styled-components.js";
import _styled28 from "../web_modules/styled-components.js";
import _styled27 from "../web_modules/styled-components.js";
import _styled26 from "../web_modules/styled-components.js";
import _styled25 from "../web_modules/styled-components.js";
import _styled24 from "../web_modules/styled-components.js";
import _styled23 from "../web_modules/styled-components.js";
import _styled22 from "../web_modules/styled-components.js";
import _styled21 from "../web_modules/styled-components.js";
import _styled20 from "../web_modules/styled-components.js";
import _styled19 from "../web_modules/styled-components.js";
import _styled18 from "../web_modules/styled-components.js";
import _styled17 from "../web_modules/styled-components.js";
import _styled16 from "../web_modules/styled-components.js";
import _styled15 from "../web_modules/styled-components.js";
import _styled14 from "../web_modules/styled-components.js";
import _styled13 from "../web_modules/styled-components.js";
import _styled12 from "../web_modules/styled-components.js";
import _styled11 from "../web_modules/styled-components.js";
import _styled10 from "../web_modules/styled-components.js";
import _styled9 from "../web_modules/styled-components.js";
import _styled8 from "../web_modules/styled-components.js";
import _styled7 from "../web_modules/styled-components.js";
import _styled6 from "../web_modules/styled-components.js";
import _styled5 from "../web_modules/styled-components.js";
import _styled4 from "../web_modules/styled-components.js";
import _styled3 from "../web_modules/styled-components.js";
import _styled2 from "../web_modules/styled-components.js";
import _styled from "../web_modules/styled-components.js";
import React from "../web_modules/react.js";
import "../web_modules/@reach/dialog/styles.css";
import "../web_modules/@ticketbutler/toolbox/dist/style.css";
import "../web_modules/@reach/menu-button/styles.css";
import { useAsyncStatus, AsyncStates } from "../web_modules/use-async-status.js";
import { useHistory, useParams } from "../web_modules/react-router-dom.js";
import SeatsIO from "../web_modules/@seatsio/seatsio-react.js";
import "./index.css";
import { Spinner, LoadingButton, formatDate, makeDate } from "../web_modules/@ticketbutler/toolbox.js";
import { SeatingDetails } from "./seating_details.js"; // @ts-expect-error: TODO: Type this

import serialize from "../web_modules/for-cerial.js";
import { useLanguage, API_HOST, makeTbRequestHeaders, FieldErrors, getFieldError, getThemedButton, makeSearchParamString } from "./app.js";
import { urlParams, isIframe, useScrollToError } from "./shared.js";
import { useTranslation } from "../web_modules/react-i18next.js";
import { CheckoutContext } from "./checkout.js"; // Seat object used for the front-end

// There is a bug in the SeatsIO library which throws when the component is unmounted. We don't care so just consume it.
class SeatsIOErrorBoundary extends React.Component {
  componentDidCatch(error, stackTrace) {
    console.error("Ignored SeatsIO error:", error, stackTrace);
  }

  render() {
    return this.props.children;
  }

}

const CHECKOUT_DIALOG_BORDER_RADIUS = 5;

var _StyledDiv = _styled("div").withConfig({
  displayName: "seating___StyledDiv",
  componentId: "g49hrk-0"
})({
  flexGrow: 1,
  // Fill content box to bottom
  display: "flex",
  justifyContent: "space-between",
  "@media (max-width: 760px)": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }
});

var _StyledDiv2 = _styled("div").withConfig({
  displayName: "seating___StyledDiv2",
  componentId: "g49hrk-1"
})(p => ({
  padding: p._css,
  width: "100%"
}));

var _StyledDiv3 = _styled("div").withConfig({
  displayName: "seating___StyledDiv3",
  componentId: "g49hrk-2"
})({
  textAlign: "center",
  marginTop: "25%"
});

var _StyledSeatsIOSeatsioSeatingChart = _styled(SeatsIO.SeatsioSeatingChart).withConfig({
  displayName: "seating___StyledSeatsIOSeatsioSeatingChart",
  componentId: "g49hrk-3"
})(p => ({
  maxWidth: p._css2,
  width: "100%"
}));

var _StyledDiv4 = _styled("div").withConfig({
  displayName: "seating___StyledDiv4",
  componentId: "g49hrk-4"
})({
  marginTop: 30
});

var _StyledDiv5 = _styled("div").withConfig({
  displayName: "seating___StyledDiv5",
  componentId: "g49hrk-5"
})({
  maxWidth: "900px",
  width: "100%"
});

var _StyledDiv6 = _styled("div").withConfig({
  displayName: "seating___StyledDiv6",
  componentId: "g49hrk-6"
})(p => ({
  fontSize: 16,
  width: 450,
  height: 35,
  backgroundColor: p._css3,
  display: "flex",
  justifyContent: "center",
  textAlign: "center",
  alignItems: "center",
  margin: "0 auto",
  marginBottom: 20,
  borderRadius: "5px",
  color: "white",
  fontWeight: 600,
  "@media (max-width: 500px)": {
    fontSize: 12,
    width: 250
  }
}));

var _StyledDiv7 = _styled("div").withConfig({
  displayName: "seating___StyledDiv7",
  componentId: "g49hrk-7"
})(p => ({
  width: p._css4,
  minHeight: p._css5,
  borderBottomRightRadius: 5,
  borderBottomLeftRadius: 5,
  margin: "0 auto",
  background: "#F9F9FC",
  boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.21)",
  display: "flex",
  justifyContent: "center",
  marginTop: p._css6,
  marginBottom: 20,
  "@media (max-width: 500px)": {
    width: "100%",
    marginTop: p._css7,
    minHeight: p._css8
  }
}));

var _StyledDiv8 = _styled("div").withConfig({
  displayName: "seating___StyledDiv8",
  componentId: "g49hrk-8"
})({
  display: "flex",
  flexDirection: "column",
  alignItems: "center"
});

var _StyledDiv9 = _styled("div").withConfig({
  displayName: "seating___StyledDiv9",
  componentId: "g49hrk-9"
})({
  color: "#63696C",
  fontSize: 12,
  fontWeight: 600,
  display: "flex",
  alignItems: "center",
  textDecoration: "underline",
  cursor: "pointer",
  margin: "auto 0",
  "@media (max-width: 500px)": {
    fontSize: 10
  }
});

var _StyledDiv10 = _styled("div").withConfig({
  displayName: "seating___StyledDiv10",
  componentId: "g49hrk-10"
})({
  display: "flex",
  flexDirection: "column",
  alignItems: "center"
});

var _StyledDiv11 = _styled("div").withConfig({
  displayName: "seating___StyledDiv11",
  componentId: "g49hrk-11"
})({
  color: "#63696C",
  fontSize: 12,
  fontWeight: 900,
  display: "flex",
  alignItems: "center",
  paddingTop: 18,
  "@media (max-width: 500px)": {
    fontSize: 10
  }
});

var _StyledForm = _styled("form").withConfig({
  displayName: "seating___StyledForm",
  componentId: "g49hrk-12"
})({
  transition: "700ms",
  paddingTop: 26,
  width: 260
});

var _StyledDiv12 = _styled("div").withConfig({
  displayName: "seating___StyledDiv12",
  componentId: "g49hrk-13"
})({
  display: "flex"
});

var _StyledInput = _styled("input").withConfig({
  displayName: "seating___StyledInput",
  componentId: "g49hrk-14"
})({
  flexGrow: 1
});

var _StyledButton = _styled("button").withConfig({
  displayName: "seating___StyledButton",
  componentId: "g49hrk-15"
})(["", ""], p => p._css9);

var _StyledSeatsIOSeatsioSeatingChart2 = _styled(SeatsIO.SeatsioSeatingChart).withConfig({
  displayName: "seating___StyledSeatsIOSeatsioSeatingChart2",
  componentId: "g49hrk-16"
})({
  maxWidth: "840px",
  width: "100%"
});

var _StyledDiv13 = _styled("div").withConfig({
  displayName: "seating___StyledDiv13",
  componentId: "g49hrk-17"
})({
  marginTop: 30
});

var _StyledDiv14 = _styled("div").withConfig({
  displayName: "seating___StyledDiv14",
  componentId: "g49hrk-18"
})({
  textAlign: "center"
});

var _StyledDiv15 = _styled("div").withConfig({
  displayName: "seating___StyledDiv15",
  componentId: "g49hrk-19"
})(p => ({
  display: "flex",
  overflow: "hidden",
  width: "100%",
  maxWidth: 300,
  padding: "10px",
  backgroundColor: "#F9F9FC",
  borderTopRightRadius: p._css10,
  borderBottomRightRadius: p._css11,
  "@media (max-width: 760px)": {
    // Expand grey box on mobile
    flex: 1,
    // Full width in mobile view
    width: "100%",
    maxWidth: "100%",
    // Add padding for Safari floating URL bars
    paddingBottom: 50
  }
}));

var _StyledDiv16 = _styled("div").withConfig({
  displayName: "seating___StyledDiv16",
  componentId: "g49hrk-20"
})({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  padding: "0 10px",
  maxHeight: 740,
  // Max height that fits in modal on desktop screen
  margin: "0 auto",
  overflowY: "hidden",
  "@media (max-width: 760px)": {
    // Fill out content from the bottom of the box on mobile
    justifyContent: "flex-end"
  }
});

var _StyledP = _styled("p").withConfig({
  displayName: "seating___StyledP",
  componentId: "g49hrk-21"
})(["", ""], p => p._css12);

var _StyledDiv17 = _styled("div").withConfig({
  displayName: "seating___StyledDiv17",
  componentId: "g49hrk-22"
})({
  overflowY: "auto"
});

var _StyledDiv18 = _styled("div").withConfig({
  displayName: "seating___StyledDiv18",
  componentId: "g49hrk-23"
})(p => ({
  backgroundColor: "white",
  borderLeft: "3px solid",
  borderColor: p._css13,
  margin: 10,
  padding: "10px 15px"
}));

var _StyledDiv19 = _styled("div").withConfig({
  displayName: "seating___StyledDiv19",
  componentId: "g49hrk-24"
})({
  marginTop: "20px"
});

var _StyledDiv20 = _styled("div").withConfig({
  displayName: "seating___StyledDiv20",
  componentId: "g49hrk-25"
})({
  marginTop: "20px"
});

var _StyledDiv21 = _styled("div").withConfig({
  displayName: "seating___StyledDiv21",
  componentId: "g49hrk-26"
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column"
});

var _StyledButton2 = _styled("button").withConfig({
  displayName: "seating___StyledButton2",
  componentId: "g49hrk-27"
})(p => ({
  fontFamily: p._css14,
  width: 230,
  height: 57,
  fontSize: 16,
  padding: "22.5px 10px",
  fontWeight: "bold",
  background: "gray",
  color: "white",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: 4,
  border: "none",
  margin: "0 auto",
  marginTop: 15,
  outline: 0
}));

var _StyledButton3 = _styled("button").withConfig({
  displayName: "seating___StyledButton3",
  componentId: "g49hrk-28"
})(["", ""], p => p._css15);

var _StyledButton4 = _styled("button").withConfig({
  displayName: "seating___StyledButton4",
  componentId: "g49hrk-29"
})(p => ({
  fontFamily: p._css16,
  width: 230,
  height: 57,
  fontSize: 16,
  padding: "22.5px 10px",
  fontWeight: "bold",
  background: "white",
  color: "rgb(128, 128, 128)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: 4,
  border: "2px solid rgb(128, 128, 128)",
  margin: "0 auto",
  marginTop: 10,
  outline: 0
}));

var _StyledDiv22 = _styled("div").withConfig({
  displayName: "seating___StyledDiv22",
  componentId: "g49hrk-30"
})({
  marginTop: "20px"
});

export function Seating({
  theme,
  event,
  whitelabel,
  onComplete,
  reservationError,
  reservationReset,
  seatsHaveTicketTypeOptions,
  NEW_RESERVATION_STATUS,
  DEFAULT_MAX_TICKETS_PER_TYPE,
  maxAvailiableTickets,
  holdToken,
  onClose
}) {
  const language = useLanguage();
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const {
    setCheckoutContext
  } = React.useContext(CheckoutContext);
  const {
    eventSlug
  } = useParams();
  const [ticketTypeNotice, setTicketTypeNotice] = React.useState(null);
  const ticketTypeNoticeTimeoutId = React.useRef(null); // If the user arrives on a checkout page but the event is expired, take
  // them back to the event page

  React.useEffect(function () {
    if (event.is_expired) {
      history.push(`/${language}/e/${eventSlug}/`);
    }
  }, [event.is_expired, eventSlug, language, history]);
  const isHousing = React.useMemo(() => whitelabel.features.includes("housing"), [whitelabel.features]); // For seating, seats are grouped by Ticket Type UUID

  const [seatsByTicketTypeUUID, setSeatsByTicketTypeUUID] = React.useState({}); // For housing, each reservation is assigned to an option

  const [reservationForOptionID, setReservationForOptionID] = React.useState({}); //For seating, set true when selected seats are valid

  const [isSeatSelctionValid, setIsSeatSelctionValid] = React.useState(false);
  const [isShowDiscountField, setIsShowDiscountField] = React.useState(false); // A flaterned list of selected seats

  const selectedSeats = Object.values(isHousing ? reservationForOptionID : seatsByTicketTypeUUID).reduce((acc, seat) => acc.concat(seat), []); /////// GET SEATING CHART FOR EVENT ////////

  const {
    trigger: getSeatingChart,
    lastResult: seatingChart,
    status: seatingChartStatus
  } = useAsyncStatus(async function getSeatingChart() {
    const req = await fetch([API_HOST, "events", event.uuid, "checkout/seating-chart/"].join("/"), {
      headers: makeTbRequestHeaders(language)
    });
    const res = await req.json();

    if (req.ok) {
      return res;
    } else {
      // TODO: Display user error
      throw Error();
    }
  });
  const seatingChartDescription = seatingChart?.description ? seatingChart?.description.replace("iframe", "iframe allowfullscreen='true'") : "";
  const {
    trigger: getTicketTypeDiscounts,
    status: GET_TICKET_TYPE_DISCOUNTS,
    lastResult: ticketTypeDiscounts,
    lastError: getTicketTypeDiscountsError
  } = useAsyncStatus(async function getTicketTypeDiscounts(code) {
    // Server validate & update the order
    const req = await fetch([API_HOST, "events", event.uuid, "ticket-types", "discount-price"].join("/") + "/", {
      method: "POST",
      headers: makeTbRequestHeaders(language),
      body: JSON.stringify({
        discount_code: code
      })
    });
    const res = await req.json();

    if (req.ok) {
      const ticketTypeDiscounts = { ...res,
        discount_code: code,
        // Destruct ticket types from wrapped array
        ticket_types: res.ticket_types.reduce(function (acc, obj) {
          return { ...acc,
            ...obj
          };
        }, {})
      };
      const totalFreeTickets = event.ticket_types.reduce(function (acc, ticketType) {
        const discountedPrice = ticketTypeDiscounts.ticket_types[ticketType.uuid]?.discounted_price;

        if (discountedPrice === 0) {
          return acc + ticketType.amount_left;
        } else return acc;
      }, 0);
      return { ...ticketTypeDiscounts,
        total_free_tickets_available: totalFreeTickets
      };
    } else {
      // Throw the error so they can be rendered
      throw res;
    }
  }, []);
  useScrollToError(Boolean(reservationError || getTicketTypeDiscountsError));
  React.useEffect(function () {
    if (event.has_seating) {
      getSeatingChart();
    }
  }, [event.has_seating, getSeatingChart]);
  React.useEffect(() => {
    if (ticketTypeNotice === null && ticketTypeNoticeTimeoutId.current !== null) {
      clearTimeout(ticketTypeNoticeTimeoutId.current);
    }
  }, [ticketTypeNotice, setTicketTypeNotice, ticketTypeNoticeTimeoutId]);
  const ticketTypesByUUID = React.useMemo(() => event.ticket_types.reduce(function (acc, ticketType) {
    acc[ticketType.uuid] = ticketType;
    return acc;
  }, {}), [event.ticket_types]);

  const onTicketPurchase = () => {
    const seats = selectedSeats.reduce((acc, selectedSeat) => {
      const ticketType = ticketTypesByUUID[selectedSeat.ticketTypeUUID];

      if (ticketType) {
        const seatingObject = {};
        seatingObject.id = String(ticketType.pk);

        if (selectedSeat.type === "GeneralAdmissionArea") {
          seatingObject.generalAdmissionArea = {
            id: selectedSeat.typeID,
            area: selectedSeat.label
          };
        } else {
          seatingObject.seats = {};
          seatingObject.seats.id = selectedSeat.typeID;

          if (selectedSeat.parentType === "table") {
            seatingObject.seats.table = selectedSeat.parent;
          }

          seatingObject.seats.section = selectedSeat.section;

          if (selectedSeat.parentType === "row") {
            seatingObject.seats.row = selectedSeat.parent;
          }

          seatingObject.seats.is_booth = selectedSeat.type === "Booth";
          seatingObject.seats.seating = selectedSeat.label;
        }

        acc.push(seatingObject);
      }

      return acc;
    }, []);
    onComplete(event.uuid, {
      seating: seats,
      holdToken: holdToken
    }, ticketTypeDiscounts?.discount_code);
  };

  function discountType(type) {
    if (type === "PERCENTAGE") {
      return "%";
    } else {
      return language === "en" ? "DKK" : "kr";
    }
  }

  return /*#__PURE__*/React.createElement(_StyledDiv, null, /*#__PURE__*/React.createElement(_StyledDiv2, {
    _css: window.innerWidth > 500 ? 30 : 10
  }, seatingChart ? event.sales_start_on ? /*#__PURE__*/React.createElement(_StyledDiv3, null, /*#__PURE__*/React.createElement("p", null, event.is_free_event ? t("event.registrationsOpen") : t("event.ticketSalesStarts"), " ", formatDate(makeDate(event.sales_start_on, true), language === "da" ? "da-DK" : undefined))) : // When there are ticket type options per seat, the data sent to
  // the chart is different to when seats just have 1 ticket type that
  // can be purchased (see `pricing` prop)
  // This results in different seatsioSeat objects sent in the event
  // callbacks.
  seatsHaveTicketTypeOptions ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SeatsIOErrorBoundary, null, /*#__PURE__*/React.createElement(_StyledSeatsIOSeatsioSeatingChart, {
    showFullScreenButton: false,
    showSectionContents: "onlyAfterZoom",
    showMinimap: false,
    publicKey: whitelabel.seating_workspace_key,
    event: seatingChart.event_key,
    language: language.toString() // Session should not be used in "kiosk" mode (used by IKANO
    // as a live-updating reservation map)
    ,
    session: urlParams.has("kiosk") ? undefined : "manual",
    holdToken: holdToken,
    objectTooltip: {
      showAvailability: true,
      showCategory: false,
      showLabel: isHousing ? false : true
    },
    tooltipInfo: isHousing ? object => object.label : undefined,
    maxSelectedObjects: event.ticket_types.map(ticketTypeItem => ({
      ticketType: ticketTypeItem.uuid,
      quantity: 1
    })),
    messages: {
      selectQuantity: t("event.selectHousePriority"),
      close: t("event.save"),
      sessionExpired: t("event.timeIsUp"),
      sessionExpiredStartOver: t("event.startOver")
    },
    onObjectClicked: () => reservationReset(),
    onObjectSelected: seatsioSeat => {
      reservationReset();
      const seat = {
        uuid: seatsioSeat.uuid,
        typeID: seatsioSeat.id,
        label: seatsioSeat.labels.own,
        category: seatsioSeat.category.label,
        color: seatsioSeat.category.color,
        ticketTypeUUID: seatsioSeat.selectedTicketType
      };
      setReservationForOptionID(reservationForOptionID => {
        if (seatsHaveTicketTypeOptions) {
          // If there is already ticket type selected for this
          // seat, show an error and deselect the seat
          // This is used to when there are fx. Adult/Child tickets
          // avalible for each seat
          const existingReservation = reservationForOptionID[seatsioSeat.id];

          if (existingReservation) {
            window.alert(isHousing ? t("event.chooseOnePriority") : t("event.chooseOneType")); // For each selected ticket type in this group deselect
            // it. We deselect all ticket types because
            // it calls onObjectDeselected, and we have no way to
            // know whether it's a user-initiated deselection or
            // this automated one.

            if (seatsioSeat.selectionPerTicketType) {
              for (const ticketTypeUUID in seatsioSeat.selectionPerTicketType) {
                seatsioSeat.deselect(ticketTypeUUID);
              }
            }

            return reservationForOptionID;
          }
        } // Add the selected seat to the seat group


        return { ...reservationForOptionID,
          [seatsioSeat.id]: seat
        };
      });
    },
    onObjectDeselected: seatsioSeat => {
      // Reset the order request state in case there was an error
      // we now want to hide
      reservationReset();
      setReservationForOptionID(reservationForOptionID => {
        const newReservationForOptionID = Object.assign({}, reservationForOptionID);
        delete newReservationForOptionID[seatsioSeat.id];
        return newReservationForOptionID;
      });
    },
    pricing: // Each seat has a set of ticket type options
    [{
      category: "reservations",
      ticketTypes: event.ticket_types.filter(({
        is_on_sale
      }) => is_on_sale).map(ticketTypeItem => {
        return {
          ticketType: ticketTypeItem.uuid,
          label: ticketTypeItem.title,
          price: isHousing ? undefined : ticketTypeItem.price
        };
      })
    }],
    priceFormatter: price => price + " " + (language === "en" ? "DKK" : "kr"),
    objectColor: function (object, defaultColor) {
      if (!object.selectable) {
        return "#8B0000";
      }

      if (object.numBooked > 0) {
        return "#e6d300";
      }

      return defaultColor;
    },
    _css2: isIframe ? undefined : "840px"
  })), seatingChartDescription && /*#__PURE__*/React.createElement(_StyledDiv4, {
    dangerouslySetInnerHTML: {
      __html: seatingChartDescription
    }
  })) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_StyledDiv5, null, ticketTypeDiscounts ? /*#__PURE__*/React.createElement(_StyledDiv6, {
    _css3: theme.colour_primary
  }, ticketTypeDiscounts.is_100_percent_discount ? ticketTypeDiscounts.discounts_left > 20 ? t("event.freePassesAvailable") : t("event.countFreePassesAvailable", {
    count_left: String(ticketTypeDiscounts.discounts_left)
  }) : t("event.achievedDiscount", {
    discount: ticketTypeDiscounts.discount_type === "TWO_FOR_ONE" ? "2for1" : ticketTypeDiscounts.discount_amount + discountType(ticketTypeDiscounts.discount_type)
  })) : /*#__PURE__*/React.createElement(_StyledDiv7, {
    _css4: isShowDiscountField ? 300 : 200,
    _css5: isShowDiscountField ? 100 : 50,
    _css6: -30,
    _css7: -10,
    _css8: isShowDiscountField ? "initial" : 30
  }, !isShowDiscountField ? /*#__PURE__*/React.createElement(_StyledDiv8, null, /*#__PURE__*/React.createElement(_StyledDiv9, {
    onClick: () => {
      setIsShowDiscountField(true);
    }
  }, t("event.addDiscountCode").toUpperCase())) : /*#__PURE__*/React.createElement(_StyledDiv10, null, /*#__PURE__*/React.createElement(_StyledDiv11, null, t("event.discountCode").toUpperCase()), /*#__PURE__*/React.createElement(_StyledForm, {
    onSubmit: function (e) {
      e.preventDefault(); // Don't submit the parent form

      e.stopPropagation();
      const {
        discount_code
      } = serialize(e.target, {
        hash: true
      }); // Reset the selected ticket types, as "select"
      // events are fired by seatsIO when the map
      // refreshes

      setSeatsByTicketTypeUUID({});
      getTicketTypeDiscounts(discount_code);
    }
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(_StyledDiv12, null, /*#__PURE__*/React.createElement(_StyledInput, {
    "data-testid": "seating-discount-code-input",
    name: "discount_code",
    maxLength: 256
  }), /*#__PURE__*/React.createElement(_StyledButton, {
    disabled: GET_TICKET_TYPE_DISCOUNTS === AsyncStates.Pending,
    _css9: [getThemedButton(theme), {
      maxWidth: "65px",
      maxHeight: "35px",
      marginLeft: "10px",
      height: 30,
      padding: 0,
      fontSize: 14
    }]
  }, GET_TICKET_TYPE_DISCOUNTS === AsyncStates.Pending ? /*#__PURE__*/React.createElement(Spinner, {
    color: "white",
    size: 30
  }) : t("event.apply"))), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(getTicketTypeDiscountsError, "discount_code")
  })))))), /*#__PURE__*/React.createElement(SeatsIOErrorBoundary, null, /*#__PURE__*/React.createElement(_StyledSeatsIOSeatsioSeatingChart2, {
    holdToken: holdToken,
    showFullScreenButton: false,
    showSectionContents: "onlyAfterZoom",
    showMinimap: false,
    publicKey: whitelabel.seating_workspace_key,
    showSectionPricingOverlay: !whitelabel.hide_price_range_seating_map,
    maxSelectedObjects: [...event.ticket_types.map(ticketType => {
      return {
        category: ticketType.title,
        quantity: DEFAULT_MAX_TICKETS_PER_TYPE
      };
    }), {
      total: event.eventsettings.order_ticket_limit > 0 ? event.eventsettings.order_ticket_limit : maxAvailiableTickets ? maxAvailiableTickets : DEFAULT_MAX_TICKETS_PER_TYPE
    }],
    event: seatingChart.event_key,
    language: language.toString(),
    messages: {
      sessionExpired: t("event.timeIsUp"),
      sessionExpiredStartOver: t("event.startOver")
    },
    selectionValidators: [{
      type: "noOrphanSeats",
      enabled: event.eventsettings.no_orphan_seats
    }],
    onSelectionValid: () => {
      setIsSeatSelctionValid(true);
    },
    onSelectionInvalid: () => {
      setIsSeatSelctionValid(false);
    },
    onObjectSelected: seatsioSeat => {
      reservationReset();
      const ticketType = event.ticket_types.find(function ({
        title
      }) {
        return title === seatsioSeat.category.label;
      });

      if (ticketType) {
        const seat = {
          uuid: seatsioSeat.uuid,
          typeID: seatsioSeat.id,
          type: seatsioSeat.objectType,
          label: seatsioSeat.labels.own,
          category: seatsioSeat.category.label,
          color: seatsioSeat.category.color,
          parentType: seatsioSeat.parent?.type,
          section: seatsioSeat.labels.section,
          parent: seatsioSeat.labels.parent,
          ticketTypeUUID: ticketType.uuid
        };
        setSeatsByTicketTypeUUID(seatsByTicketTypeUUID => ({ ...seatsByTicketTypeUUID,
          [seat.ticketTypeUUID]: [...(seatsByTicketTypeUUID[seat.ticketTypeUUID] || []), seat]
        }));
      } // TODO: What should we do if we can't find the ticket type
      // associated with the selected seat?

    },
    session: "manual",
    onObjectClicked: seatsioSeat => {
      const ticketType = event.ticket_types.find(function ({
        title
      }) {
        return title === seatsioSeat.category.label;
      });

      if (seatsioSeat.objectType === "GeneralAdmissionArea") {
        setTicketTypeNotice(null);

        if (ticketType && ticketType.description !== "") {
          setTicketTypeNotice(ticketType.description);
        }

        const timeId = setTimeout(() => {
          setTicketTypeNotice(null);
        }, 15000);
        ticketTypeNoticeTimeoutId.current = timeId;
      }
    },
    onObjectDeselected: seatsioSeat => {
      // Reset the order request state in case there was an error
      // we now want to hide
      reservationReset();
      const ticketType = event.ticket_types.find(function ({
        title
      }) {
        return title === seatsioSeat.category.label;
      });

      if (ticketType) {
        setSeatsByTicketTypeUUID(seatsByTicketTypeUUID => {
          let seatsForTicketType = seatsByTicketTypeUUID[ticketType.uuid]; // GeneralAdmissionArea object UUIDs are not unique,
          // so let's just take one seat object out.

          if (seatsioSeat.objectType === "GeneralAdmissionArea") {
            // Find the first GenerlAdmissionArea in the list
            // and remove it
            for (let i = 0; i < seatsForTicketType.length; i++) {
              const seat = seatsForTicketType[i];

              if (seat.type === "GeneralAdmissionArea") {
                seatsForTicketType.splice(i, 1);
                break;
              }
            }
          } else {
            seatsForTicketType = seatsForTicketType.filter(function (seat) {
              return seat.uuid !== seatsioSeat.uuid;
            });
          }

          return { ...seatsByTicketTypeUUID,
            [ticketType.uuid]: seatsForTicketType
          };
        });
      }
    },
    pricing: ticketTypeDiscounts ? event.ticket_types.map(function (ticketType) {
      const discount = ticketTypeDiscounts.ticket_types[ticketType.uuid];
      const discountedPrice = discount.discounted_price !== discount.original_price ? discount.discounted_price : null;
      return {
        category: ticketType.title,
        price: discountedPrice !== null ? discountedPrice : ticketType.price,
        originalPrice: discountedPrice !== null ? discount.original_price : undefined
      };
    }) : event.ticket_types.map(ticketType => ({
      category: ticketType.title,
      price: ticketType.price
    })),
    priceFormatter: price => price + " " + (language === "en" ? "DKK" : "kr"),
    objectIcon: function (object, defaultIcon) {
      // Show an icon for free seats after discount
      if (object.pricing?.originalPrice) {
        if (object.pricing.price !== object.pricing.originalPrice && object.pricing.price === 0) {
          return "star";
        }
      }

      return defaultIcon;
    }
  })), seatingChartDescription && /*#__PURE__*/React.createElement(_StyledDiv13, {
    dangerouslySetInnerHTML: {
      __html: seatingChartDescription
    }
  })) : seatingChartStatus === AsyncStates.Error ? /*#__PURE__*/React.createElement("p", null, t("event.errorTryAgain")) : /*#__PURE__*/React.createElement(_StyledDiv14, null, /*#__PURE__*/React.createElement(Spinner, {
    color: theme.colour_primary
  }))), /*#__PURE__*/React.createElement(_StyledDiv15, {
    _css10: CHECKOUT_DIALOG_BORDER_RADIUS,
    _css11: CHECKOUT_DIALOG_BORDER_RADIUS
  }, /*#__PURE__*/React.createElement(_StyledDiv16, null, ticketTypeNotice !== null && /*#__PURE__*/React.createElement(AdvancedInfoModal, {
    ticketTypeDescription: ticketTypeNotice
  }), /*#__PURE__*/React.createElement(_StyledP, {
    _css12: [{
      fontSize: 14,
      fontWeight: "bold",
      textAlign: "center",
      // Summary heading exists already in mobile mode
      "@media (max-width: 760px)": {
        display: "none"
      }
    }]
  }, isHousing ? t("event.housingSummary") : event.is_free_event ? t("event.registrationSummary") : t("event.orderSummary")), /*#__PURE__*/React.createElement(_StyledDiv17, null, selectedSeats.map(seat => {
    const ticketType = ticketTypesByUUID[seat.ticketTypeUUID]; // Apply discounted price to overview

    const discountedPrice = ticketTypeDiscounts?.ticket_types[seat.ticketTypeUUID]?.discounted_price;

    if (typeof discountedPrice === "number") {
      ticketType.price = discountedPrice;
    }

    return /*#__PURE__*/React.createElement(_StyledDiv18, {
      key: `${seat.ticketTypeUUID}_${seat.typeID}`,
      _css13: seat.color
    }, /*#__PURE__*/React.createElement(SeatingDetails, {
      seat: seat,
      whitelabel: whitelabel,
      ticketType: ticketType
    }));
  })), isHousing ? /*#__PURE__*/React.createElement(_StyledDiv19, null, t("event.totalReservations") + " ", " ", selectedSeats.length, " ", t("out of 2.")) : /*#__PURE__*/React.createElement(_StyledDiv20, null, /*#__PURE__*/React.createElement("strong", null, t("event.total") + " ", ": "), selectedSeats.length, " ", event.is_free_event ? selectedSeats.length === 1 ? t("event.reservation") : t("event.reservations") : selectedSeats.length == 1 ? t("event.ticket").toLowerCase() : t("event.tickets").toLowerCase()), /*#__PURE__*/React.createElement(_StyledDiv21, null, !isHousing && !isSeatSelctionValid && selectedSeats.length >= 1 || selectedSeats.length === 0 ? /*#__PURE__*/React.createElement(_StyledButton2, {
    _css14: theme.font_family
  }, event.is_free_event ? t("event.reserve") : t("event.checkout")) : /*#__PURE__*/React.createElement(LoadingButton, {
    loading: NEW_RESERVATION_STATUS === AsyncStates.Pending,
    success: NEW_RESERVATION_STATUS === AsyncStates.Success,
    successMessage: /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 34,
        lineHeight: 0.5
      }
    }, "\u2714")
  }, /*#__PURE__*/React.createElement(_StyledButton3, {
    onClick: function (e) {
      e.preventDefault();

      if (isHousing && selectedSeats.length === 1) {
        if (window.confirm(t("event.registerHousesWarningMessage"))) {
          onTicketPurchase();
        }
      } else {
        onTicketPurchase();
      }
    },
    _css15: [getThemedButton(theme), {
      margin: "0 auto",
      marginTop: 15
    }]
  }, event.is_free_event ? t("event.reserve") : t("event.checkout"))), /*#__PURE__*/React.createElement(FieldErrors, {
    errors: getFieldError(reservationError, "non_field_errors")
  }), !isHousing && !isSeatSelctionValid && selectedSeats.length >= 1 && /*#__PURE__*/React.createElement("span", {
    style: {
      color: "red",
      fontSize: 12,
      textAlign: "center"
    }
  }, t("event.seatingSelectionInvalid"))), /*#__PURE__*/React.createElement(_StyledButton4, {
    onClick: async function () {
      // Confirm before closing modal
      if (window.confirm(t("event.reservationWillBeLost"))) {
        setCheckoutContext(s => ({ ...s,
          warnBeforeExit: false
        }));
        onClose(); // await releaseSeatsioObjects();
        // If we are in detailed iframe mode, and we have come from an event list
        // or calendar, closing the modal should send a message to the host page
        // to close the pop-over modal

        if (isIframe) {
          parent.postMessage({
            type: "TICKETBUTLER_CHECKOUT_MODAL",
            open: false
          }, "*");
          return;
        } else {
          history.push([`/${language}/e`, eventSlug, makeSearchParamString(["purchase_uuid", undefined])].filter(Boolean).join("/"));
        }
      }
    },
    _css16: theme.font_family
  }, t("event.seatingCancel")), seatingChart && /*#__PURE__*/React.createElement(_StyledDiv22, {
    dangerouslySetInnerHTML: {
      __html: language === "da" && seatingChart.additional_info_html_da ? seatingChart.additional_info_html_da : language === "en" && seatingChart.additional_info_html_en ? seatingChart.additional_info_html_en : ""
    }
  }))));
}

function AdvancedInfoModal({
  ticketTypeDescription
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      background: "white",
      borderRadius: "10px",
      marginTop: "10px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 10,
      width: "100%",
      fontSize: "14px"
    }
  }, ticketTypeDescription));
}